import { cva } from "class-variance-authority";

/**
 * Overline Variants
 *
 * V&A Waterfront Design System - Overline Text Primitive
 *
 * Lightweight uppercase text used as eyebrow/label above headings.
 * Responsive typography: mobile (12px) → desktop (14px).
 */
export const overlineVariants = cva(
  "typography-mobile-heading-overline desktop:typography-desktop-heading-overline",
  {
    variants: {
      variant: {
        default: "text-[color:var(--overline-color,var(--color-text-primary))]",
        muted: "text-[color:var(--overline-color,var(--color-text-secondary))]",
        "on-dark": "text-white",
      },
    },
    defaultVariants: {
      variant: "muted",
    },
  },
);
